import _ from 'lodash'
import { createContext, useContext, useEffect, useReducer, useRef, useState } from 'react'
import { golfRoundHandlers, golfRoundInitialState, golfRoundReducer } from '../reducers/GolfRoundReducer'
import { GolfParentContext } from './GolfParentContext'
import { buildFcmPayload } from 'global/functions/fbNotifications'
import { ParentContext } from 'global/cnr/contexts/ParentContext'

const _matchUpdateTime = 1500

export const GolfRoundContext = createContext();

export const GolfRoundProvider = (props) => {

  const { roundKey, roundKeyDirect, displaySize } = props

  const _roundKey = roundKeyDirect ? roundKeyDirect : roundKey

  const parentContext = useContext(ParentContext);
  const { fn_cls } = parentContext ?? {}

  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, handlers } = golfParent_contexts ?? {}
  const { golfTournament_state } = states ?? {}
  const { golfTournament_handlers } = handlers ?? {}

  const { matches_rounds, roundsStatus, autoScoringOn, autoScoringRoundKey } = golfTournament_state ?? {}

  const init_state = { roundKey: _roundKey, initDisplaySize: displaySize, matchUpdateTime: _matchUpdateTime }
  const [golfRound_state, golfRound_dispatch] = useReducer(golfRoundReducer, init_state, golfRoundInitialState)
  const golfRound_handlers = golfRoundHandlers(golfRound_dispatch, golfRound_state)
  const { roundStatus, matches_round, roundMatches, matchUpdateTime } = golfRound_state
  const { matchStatuses } = roundStatus ?? {}
  const { handleAmmend_golfRound, handleAmmend_matchUpdater } = golfRound_handlers

  const [currentRoundMatches, setCurrentRoundMatches] = useState()
  const [runRandomMatches, setRunRandomMatches] = useState(true)

  const [matchIndex, setMatchIndex] = useState(null); // index the UI should highlight  

  useEffect(() => {
    if (_roundKey) {
      if (matches_rounds && roundsStatus) {
        const _roundStatus = roundsStatus[_roundKey]
        const _roundMatches = matches_rounds[_roundKey]
        handleAmmend_golfRound(_roundKey, _roundStatus, _roundMatches)
      } else {
        handleAmmend_golfRound(_roundKey, {}, {})
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches_rounds, roundsStatus, _roundKey]);

  const updateMatch = (rm) => {

    const handleUpdated = () => { handleAmmend_matchUpdater(rm, true) }

    if (!rm.finished) {
      const activeHoleNumber = rm?.holeWinners ? _.last(_.keys(rm?.holeWinners)) : 0;
      const newHoleNumber = _.toInteger(activeHoleNumber) + 1

      const matchUpdate = {
        golfMatch: rm,
        holeNumber: newHoleNumber,
        winningTeam: Math.floor(Math.random() * 3),
        playerScoring: null,
        lowScores: null
      }
      let matchStatus = matchStatuses?.[rm?._itemKey] ?? null;
      if (matchStatus.leadingBy - matchStatus.holesRemaining >= 3) {
        console.log('matchStatus', matchStatus)
      }
      golfTournament_handlers.handleUpdate_golfMatchScore(matchUpdate, handleUpdated, matchStatus)
    }
  }

  useEffect(() => {
    if (!autoScoringOn ||
      !autoScoringRoundKey ||
      !runRandomMatches ||
      _.size(currentRoundMatches) === 0 ||
      (_roundKey !== autoScoringRoundKey)
    ) return;

    const matchesArray = _.sortBy(_.values(currentRoundMatches), 'matchNumber'); // sorted by matchNumber

    const interval = setInterval(() => {

      if (matchesArray.length === 0) return;

      const nextMatch = matchesArray[matchIndex]; // update the current one

      if (nextMatch && !nextMatch.finished) {
        updateMatch(nextMatch);
      }

      // move to next index (wraps around)s
      setMatchIndex((prev) => {
        const newIndex = (prev + 1) % matchesArray.length;
        handleAmmend_matchUpdater(matchesArray[newIndex])
        return newIndex;
      });
    }, matchUpdateTime);

    return () => clearInterval(interval);

  }, [currentRoundMatches, autoScoringOn, runRandomMatches]);

  useEffect(() => {
    if (roundStatus && roundMatches) {

      const availableMatches = {};

      // get the available matches for the round
      _.forEach(roundMatches, (match_round, match_round_key) => {
        let matchStatus = matchStatuses?.[match_round_key] ?? null;
        if (!matchStatus?.finished) {
          // if the match is NOT finished, add it to availableMatches 
          availableMatches[match_round_key] = match_round;
        }
      });

      if (_.isEmpty(availableMatches)) {
        setRunRandomMatches(false);
      } else {
        setRunRandomMatches(true);
      }

      // only reset index if the actual list of available matches changes (not just their contents)
      const oldKeys = Object.keys(currentRoundMatches ?? {});
      const newKeys = Object.keys(availableMatches);

      const keysChanged =
        oldKeys.length !== newKeys.length ||
        !_.isEqual(_.sortBy(oldKeys), _.sortBy(newKeys));

      if (keysChanged) {
        setMatchIndex(0);
      }

      setCurrentRoundMatches(availableMatches);
    }
  }, [roundKey, roundMatches, autoScoringOn, autoScoringRoundKey]);

  return (
    <GolfRoundContext.Provider value={{ golfRound_handlers, golfRound_state }} >
      {props.children}
    </GolfRoundContext.Provider>
  )
}
